// listing & create route
const GasList = () => import("./list/index.vue");
const CreateGasPage = () => import("./list/_pages/create.vue");
const GasViewPage = () => import("./list/_pages/view.vue");
const EmptyPage = () => import("./empty-cylinder.vue");

const Index = () => import("./price-lists/index.vue");
const ManagePage = () => import("./price-lists/_pages/manage.vue");
const SinglePage = () => import("./price-lists/_pages/single.vue");
const MultiplePage = () => import("./price-lists/./_pages/multiple.vue");

export default [
  {
    path: "/gas/price-lists",
    component: Index,
    children: [
      {
        path: "",
        component: SinglePage,
      },
      {
        path: "multiple/update/:id",
        component: MultiplePage,
      },
    ],
  },
  {
    path: "/gas/price-lists/manage/:id",
    component: ManagePage,
  },
  {
    path: "/gas/products",
    component: GasList,
  },
  {
    path: "/new-gas",
    component: CreateGasPage,
  },
  {
    path: "/gas/:id",
    component: GasViewPage,
  },
  {
    path: "/empty/cylinders",
    component: EmptyPage,
  },
];
